module.exports = __webpack_public_path__ + "static/media/beaconHome-1024w.2682f16f.jpg";